<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row type="flex">
        <el-col :span="24">
          <div class="box">
            <div class="header"><h3>修改密码</h3></div>

            <el-col :md="16" :lg="12" :xl="8">
              <div class="formDiv">
                <el-form :model="form" ref="formData" label-width="100px">
                  <el-form-item label="新密码" prop="password" :rules="ruleAccountPwd">
                    <el-input placeholder="" v-model="form.password" :show-password="true"></el-input>
                  </el-form-item>

                  <el-form-item label="重复密码" prop="password2" :rules="ruleAccountPwd2">
                    <el-input placeholder="" v-model="form.password2" :show-password="true"></el-input>
                  </el-form-item>

                  <el-form-item label="手机号码" prop="mobile" :rules="rulePhone">
                    <el-input ref="mobile" placeholder="绑定的手机号码" v-model="form.mobile"></el-input>
                  </el-form-item>

                  <el-form-item
                    label="图形验证码"
                    prop="captchaCode"
                    :rules="{
                      required: true,
                      min: 4,
                      max: 4,
                      message: '请填写4位数的图形验证码',
                      trigger: 'blur',
                    }"
                  >
                    <el-row>
                      <el-col :span="8">
                        <div>
                          <el-input ref="captchaCode" oninput="if(value.length>4)value=value.slice(0,4)" placeholder="图形验证码" v-model="form.captchaCode"></el-input>
                        </div>
                      </el-col>

                      <el-col :span="9">
                        <el-image :src="'data:image/png;base64,' + captchaSrc" style="height: 40px" alt="单击刷新验证码" @click="loadCaptcha"></el-image>
                      </el-col>
                      <el-col :span="7">
                        <div style="padding-left: 10px">
                          <ButtonCountDown style="width: 100%" ref="ButtonCountDown" type="primary" text="发送短信" count="60" :method="sendSMS"></ButtonCountDown>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form-item>

                  <el-form-item label="短信验证码" prop="smsCode" v-show="sendSMSed">
                    <el-row>
                      <el-col :span="8">
                        <div>
                          <el-input ref="smsCode" oninput="if(value.length>4)value=value.slice(0,4)" placeholder="短信验证码" v-model="form.smsCode"></el-input>
                        </div>
                      </el-col>
                      <el-col :span="16">
                        <div style="margin-left: 15px">输入收到的4位数短信验证码</div>
                      </el-col>
                    </el-row>
                  </el-form-item>

                  <el-form-item>
                    <el-button :disabled="!sendSMSed" type="primary" style="width: 100%" @click="submit">确定修改密码</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px">
      <span>{{ dialogContent }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ButtonCountDown from "@/components/ButtonCountDown.vue"

import personApi from "@/api/person"
import captchaApi from "@/api/captcha"
import { validAccountPwd, validPhone } from "@/utils/valid"

export default {
  components: { PageHeader, ButtonCountDown },
  data() {
    var validAccountPwdFun = (rule, value, callback) => {
      if (!validAccountPwd(value)) {
        callback(new Error("长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)"))
      } else {
        callback()
      }
    }

    var validAccountPwd2Fun = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"))
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"))
      } else {
        callback()
      }
    }
    var validPhoneFun = (rule, value, callback) => {
      if (!validPhone(value)) {
        callback(new Error("手机号码格式不正确"))
      } else {
        callback()
      }
    }
    return {
      headLinks: [
        { path: "", title: "账号信息" },
        { path: "", title: "修改密码" },
      ],
      captchaSrc: "",
      sendSMSed: false,
      dialogType: "",
      dialogVisible: false,
      dialogContent: "",
      form: {
        mobile: "",
        captchaCode: "",
        captchaCodeKey: "",
        smsCode: "",
        password: "",
        password2: "",
      },
      ruleAccountPwd: [
        {
          required: true,
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个字符(必须包含数字/小写字母/大写字母)",
          trigger: "blur",
        },
        { validator: validAccountPwdFun, trigger: "blur" },
      ],

      ruleAccountPwd2: [{ validator: validAccountPwd2Fun, trigger: "blur" }],
      rulePhone: [
        {
          required: true,
          trigger: "blur",
          message: "手机号码必须填写",
        },
        { validator: validPhoneFun, trigger: "blur" },
      ],
    }
  },
  mounted() {
    this.loadCaptcha()
  },

  methods: {
    dialogOpen(type, content) {
      this.dialogType = type
      this.dialogContent = content
      this.dialogVisible = true
    },
    dialogClose() {
      if (this.dialogType == "mobile") {
        this.$refs["mobile"].focus()
      } else if (this.dialogType == "captchaCode") {
        this.$refs["captchaCode"].focus()
      } else if (this.dialogType == "smsCode") {
        this.$refs["smsCode"].focus()
      }
      this.dialogType = null
      this.dialogVisible = false
    },
    loadCaptcha() {
      captchaApi.image("char").then((res) => {
        if (res.code == 0) {
          this.captchaSrc = res.data.img
          this.form.captchaCodeKey = res.data.key
        }
      })
    },

    sendSMS() {
      Promise.all(
        ["mobile", "captchaCode"].map((item) => {
          return new Promise((resolve) => {
            this.$refs.formData.validateField(item, (error) => {
              resolve(error)
            })
          })
        })
      ).then((data) => {
        if (data.length <= 0 || (data[0] == "" && data[1] == "")) {
          this.$refs.ButtonCountDown.start()
          personApi.sendSMSForResetPassword(this.form.mobile, this.form.captchaCode, this.form.captchaCodeKey).then((res) => {
            if (res.code == 0) {
              this.sendSMSed = true
              this.dialogOpen("smsCode", "短信验证码已经发送到手机上，请注意查看")
            } else {
              this.$refs.ButtonCountDown.stop()
              this.dialogOpen("", "发送短信失败," + res.code.mobile)
            }
          })
        }
      })
    },

    submit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          personApi.resetPassword(this.form).then((res) => {
            if (res.code == 0) {
              this.$notify({
                title: "成功",
                message: "修改密码成功，请牢记密码",
                type: "success",
              })
            } else if (res.code == 1) {
              this.dialogOpen("", res.msg)
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  margin: 30px;
  border: 1px solid #e2e2e2;
  padding: 15px 25px;
  height: 100%;

  .header {
    line-height: 44px;
  }
}

.formDiv {
  margin: 20px;
}
</style>
